import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';

export default ({ data, openItem, setStateDetail }) => {
  // this prop is a must in currentState.params
  const itemStyle = {
    padding: '20px 40px 40px 40px',
    textAlign: 'left',
  };
  const noDataStyles = {
    fontWeight: 300,
    fontSize: 24,
    color: 'rgb(39, 179, 251)',
    marginLeft: 20,
  };
  return (
    <div className="direction-overlay">
      {data.map((location) => (
        <div className="item col-md-4" key={location.id} style={itemStyle}>
          <h3>{location.reception_title}</h3>
          {/*<p>{location.address},
                <FormattedMessage {...messages.trsPhone} />: {location.phone}</p>*/}
          <a
            className="button sp-search-btn"
            onClick={() => {
              setStateDetail('contacts');
              openItem({
                id: location.id,
                region: {
                  id: location.region_id,
                  title: location.region_title,
                },
              });
            }}>
            <FormattedMessage {...messages.contacts} />
          </a>
          <a
            className="button-green sp-search-btn"
            onClick={() => {
              setStateDetail('appeal');
              openItem({
                id: location.id,
                region: {
                  id: location.region_id,
                  title: location.region_title,
                },
              });
            }}>
            <FormattedMessage {...messages.appeal} />
          </a>
          {/* <a
            className="button sp-search-btn"
            onClick={() => {
              setStateDetail('appeal');
              openItem({
                id: location.id,
                region: {
                  id: location.region_id,
                  title: location.region_title,
                },
              });
            }}>
            <FormattedMessage {...messages.more} />
          </a> */}
        </div>
      ))}

      {(!data || data.length === 0) && (
        <h5 style={noDataStyles}>
          <FormattedMessage {...messages.noData} />
        </h5>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/apps/receptions/views/SearchResults.js